/*
 * Product card color swatches on touch devices.
 */
(function () {
  const OPEN_CLASS = 'swatches-open';
  const CARD = '.product-item';
  const AREA = '.product-swatches-area';
  const TRIGGER = '.swatches-default-state';
  const TAP_MOVE_LIMIT = 10;
  const TAP_TIME_LIMIT = 400;

  let tap = null;

  function isTouch() {
    return window.matchMedia('(hover: none)').matches;
  }

  function closeAll(except) {
    document.querySelectorAll(CARD + '.' + OPEN_CLASS).forEach(function (card) {
      if (card !== except) card.classList.remove(OPEN_CLASS);
    });
  }

  document.addEventListener(
    'touchstart',
    function (event) {
      tap = null;
      if (!isTouch() || !(event.target instanceof Element)) return;

      const area = event.target.closest(AREA);
      const trigger = event.target.closest(TRIGGER);
      const card = area ? area.closest(CARD) : null;
      const touch = event.changedTouches[0];

      // taps inside the open card's own swatch area must not close it
      closeAll(card);

      if (!trigger || !card) return;
      tap = {
        x: touch.clientX,
        y: touch.clientY,
        time: Date.now(),
        card: card,
      };
    },
    { passive: true },
  );

  document.addEventListener(
    'touchend',
    function (event) {
      const started = tap;
      tap = null;
      if (!started) return;

      const touch = event.changedTouches[0];
      const moved =
        Math.abs(touch.clientX - started.x) > TAP_MOVE_LIMIT ||
        Math.abs(touch.clientY - started.y) > TAP_MOVE_LIMIT;
      if (moved || Date.now() - started.time > TAP_TIME_LIMIT) return;

      started.card.classList.add(OPEN_CLASS);
    },
    { passive: true },
  );

  document.addEventListener('touchcancel', function () {
    tap = null;
  });
})();
